import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import {
  WorkflowPageTitle,
  WorkflowTopNav,
  NavItem,
  NavSpacer,
  Authorized
} from "../../common";
import { withRouter } from "react-router-dom";
import { ReactSVG } from "react-svg";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

const styles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  brandButton: {
    backgroundColor: "transparent"
  },
  brandLogo: {
    height: "56px"
  },
  brandIcon: {
    height: "56px"
  },
  navItem: {
    ...theme.mixins.navItem
  },
  toolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.up("md")]: {
      marginTop: "24px"
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px"
    }
  }
});

function addCssClass(elm, cssClass) {
  if (!!elm.classList) {
    elm.classList.add(cssClass);
  } else if (elm.nodeName === "svg" || elm.nodeName === "SVG") {
    // https://caniuse.com/#search=classList
    // IE11 really does not do <svg> properly :-/
    let appliedClasses = elm.getAttribute("class") || "";
    appliedClasses = !appliedClasses.split(" ").includes(cssClass)
      ? `${elm.className} ${cssClass}`
      : appliedClasses;
    elm.setAttribute("class", appliedClasses);
  }
}

export default withStyles(styles, { name: "Nav" })(
  withRouter(
    class Nav extends PureComponent {
      render = () => {
        const {
          classes,
          location: { pathname },
          icon,
          logo
        } = this.props;

        let xsLogo = null;
        if (typeof icon === "string") {
          xsLogo = icon.endsWith("svg") ? (
            <ReactSVG
              src={icon}
              beforeInjection={elm => {
                addCssClass(elm, classes.brandIcon);
              }}
            />
          ) : (
            <img src={icon} className={classes.brandIcon} alt="brand-icon" />
          );
        } else if (icon) {
          const Icon = icon;
          xsLogo = <Icon />;
        }

        let smLogo = null;
        if (typeof logo === "string") {
          smLogo = logo.endsWith("svg") ? (
            <ReactSVG
              src={logo}
              beforeInjection={elm => {
                addCssClass(elm, classes.brandLogo);
              }}
            />
          ) : (
            <img src={logo} className={classes.brandLogo} alt="brand-logo" />
          );
        } else if (logo) {
          const Logo = logo;
          smLogo = <Logo />;
        }

        const brandNav =
          (xsLogo && smLogo && (
            <NavItem
              className={classes.brandButton}
              url="/"
              onClick={this.goHome}
            >
              <Hidden smUp implementation="css">
                {xsLogo}
              </Hidden>
              <Hidden xsDown implementation="css">
                {smLogo}
              </Hidden>
            </NavItem>
          )) ||
          null;

        let demoNotice = <NavSpacer />;
        if (process.env.CONFIG !== "production") {
          demoNotice = (
            <Box flexGrow="1" display="flex" justifyContent="center">
              <Box bgcolor="red" px={2}>
                <Typography>
                  DEMO ({process.env.CONFIG}.{window.appInfo.theme})
                </Typography>
              </Box>
            </Box>
          );
        }

        return (
          <Authorized>
            <AppBar position="fixed" className={classes.appBar}>
              <Toolbar>
                {brandNav}
                {pathname === "/" ? null : (
                  <>
                    <WorkflowPageTitle />
                    <WorkflowTopNav hideButtons />
                  </>
                )}
                {demoNotice}
                <NavItem
                  icon={ExitToAppIcon}
                  url="/logout"
                  tooltip={{ title: "Logout" }}
                  className={classes.navItem}
                />
              </Toolbar>
            </AppBar>
          </Authorized>
        );
      };
    }
  )
);
